export const user_types = [
  { id: 1, name: "현장관리자" },
  { id: 2, name: "건설사" },
  { id: 3, name: "시스템관리자" },
];

export const communicator_event_types = [
  { id: 1, label: "대피알림" },
  { id: 2, label: "SOS" },
];
